app
  .controller("FeaturedContentController", [
    "$scope",
    "getSiteDetails",
    function ($scope, getSiteDetails) {
      $scope.subtitle = $scope.payload.subtitle;
      $scope.title = $scope.payload.title;
      $scope.description = $scope.payload.description;
      if ($scope.payload) {
        getSiteDetails
          .getPlaylistContent($scope.payload.playlistID)
          .then((result) => {
            if (result.content.length) {
              $scope.featuredLivePlaylist = result.content[0].playlistContent;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  ])
  .directive("featuredContentPlaylist", [
    function () {
      return {
        restrict: "AE",
        transclude: true,
        scope: {
          payload: "=",
        },
        templateUrl: "template/elements/featured.html",
      };
    },
  ]);
